/* eslint-disable */
import React, { useEffect, useState } from 'react';
import logo from '../../../img/automatbLogo.png';
import * as API from '../../../framework/API/api_digitalSign';
import { useTranslation } from '../../../locale/useTranslation';
import { LOGIN_WARNING_MESSAGE, TOAST_TYPES } from '../../../framework/constant/constant';
import { ToastContainer } from 'react-toastify';
import image from '../../../img/The-Power-of-Billboard-Advertising-1.jpg';
import { useNavigate } from 'react-router-dom';
import InstanceLoginForm from '../../login/InstanceLoginForm';
import ToastNotification from '../../../components/ToastNotification';

const DigitalSignLoginForm = (props) => {

    const { handleLoginClick, showError = false, showInstanceForm = false, handleInstanceOkClick, setShowInstanceForm, loginResponse } = props;

    const lang = useTranslation();
    const navigate = useNavigate();
    const emailRegex = new RegExp(/\S+@\S+\.\S+/);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const labelStyle = {
        color: '#7b838a',
        textTransform: 'uppercase',
        letterSpacing: '.1rem'
    };

    const handleLogin = (e) => {
        let event = {
            ...e,
            target: {
                username: { value: email },
                password: { value: password },
            }
        };
        handleLoginClick(event);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleLogin(event);
        }
    };

    const handleTogglePassword = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (email == undefined || email == "" || !emailRegex.test(email)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_email_error_message, });
            return;
        }

        let res = await API.forgotPassword(email);
        console.log(res);
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            setShowForgotPassword(false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <div className="container-fluid vh-100 d-flex digital-sign-login-container">
                <div
                    className="position-absolute w-100 h-100 digital-sign-login-background"
                    style={{
                        backgroundImage: `url(${image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(10px)',
                        zIndex: -1,
                        position: 'relative',
                    }}
                ></div>
                <div className="d-flex justify-content-end align-items-center w-100 text-center digital-sign-login-heading">
                    <div>
                        Manage Your Digital Signage Efficiently, Anytime & from Anywhere
                    </div>
                </div>
                <div className="d-flex justify-content-end align-items-center w-100 h-100 digital-sign-login-content">
                    <div className="d-flex flex-column justify-content-end align-items-start p-5 bg-white digital-sign-up-login-form" style={{ borderRadius: '5px', width: showInstanceForm && '60%' }}>
                        <img src={logo} alt="Logo" className="mb-4" style={{ width: '200px' }} />
                        {!showForgotPassword
                            ? <>
                                <h2 style={{ fontSize: '3rem', marginBottom: '20px', lineHeight: 1, fontWeight: 600, letterSpacing: '.1rem' }}>{lang.sign_in_label}</h2>
                                <div className="slider-wrapper">
                                    <div className="slider">
                                        {showInstanceForm ?
                                            <div className="slide">
                                                <InstanceLoginForm
                                                    labelStyle={labelStyle}
                                                    isDigitalSignage={true}
                                                    instances={loginResponse?.data?.Instances ?? []}
                                                    cancelClick={() => setShowInstanceForm(false)}
                                                    okClick={handleInstanceOkClick}
                                                />
                                            </div> :
                                            <div className="slide">
                                                <div className="mb-3 w-100">
                                                    <label htmlFor="email" style={labelStyle}>{lang.email_label}</label>
                                                    <input
                                                        style={{ padding: "10px 20px", display: 'inline-block' }}
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder="Type email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        onKeyDown={handleKeyDown}
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3 w-100">
                                                    <label htmlFor="password" style={labelStyle}>{lang.password_label}</label>
                                                    <input
                                                        style={{ padding: "10px 20px", display: 'inline-block' }}
                                                        type={showPassword ? 'text' : 'password'}
                                                        className="form-control"
                                                        name="password"
                                                        placeholder="Type password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        onKeyDown={handleKeyDown}
                                                        required
                                                    />
                                                    <i style={{ position: "absolute", marginLeft: '-26px', marginTop: '11px', cursor: "pointer" }} className={`icon-append fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} onClick={handleTogglePassword} />
                                                </div>
                                                <div className="mb-3">
                                                    <a onClick={(e) => { e.preventDefault(); setShowForgotPassword(true); }} className="text-primary cursor-pointer">{lang.forgot_password_label}</a>
                                                </div>
                                                {showError && <div ng-show="error" className="alert alert-danger">
                                                    <a href="# " className="close" data-dismiss="alert"><span></span></a>{LOGIN_WARNING_MESSAGE}
                                                </div>}
                                                <button
                                                    onClick={handleLogin}
                                                    type="submit"
                                                    style={{ backgroundColor: (email && password) ? '#275B89' : '#ACB5BD', color: 'white' }}
                                                    disabled={(email && password) ? false : true}
                                                    className="btn mb-3"
                                                >
                                                    {lang.login_label}
                                                </button>
                                                {/* Signup */}
                                                <p>{lang.do_not_have_an_account_label} <a onClick={() => navigate('/signup')} className="text-primary cursor-pointer">{lang.sign_up_label}</a></p>
                                            </div>}
                                    </div>
                                </div>
                            </> :
                            <>
                                <h2 style={{ fontSize: '2rem', marginBottom: '20px', lineHeight: 1, fontWeight: 600, letterSpacing: '.1rem' }}>{lang.forgot_your_password_label}</h2>
                                <p>{lang.enter_email_note}</p>
                                <div className="mb-3 w-100">
                                    <label htmlFor="email" style={labelStyle}>{lang.email_label}</label>
                                    <input
                                        style={{ padding: "10px 20px", display: 'inline-block' }}
                                        type="email"
                                        className="form-control"
                                        name="email"
                                        placeholder="Type email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        required
                                    />
                                </div>
                                <button
                                    onClick={handleForgotPassword}
                                    type="submit"
                                    style={{ backgroundColor: email ? '#275B89' : '#ACB5BD', color: 'white' }}
                                    disabled={email ? false : true}
                                    className="btn mb-3"
                                >
                                    {lang.reset_password_button_text}
                                </button>
                                <p>{lang.remember_password_label} <a onClick={(e) => { e.preventDefault(); setShowForgotPassword(false); }} className="text-primary cursor-pointer">{lang.sign_in_label}</a></p>
                            </>}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}

export default DigitalSignLoginForm;